import { render, staticRenderFns } from "./SpouseInfoForm.vue?vue&type=template&id=1f23a148"
import script from "./SpouseInfoForm.vue?vue&type=script&lang=js"
export * from "./SpouseInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports